import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SubjectCard.css';
import { subjects } from '../../../../../http/coursesAPI';

import defaultImage from '../../../../../assets/images/BoostDarkLogo.svg';
import biology from  '../../../../../assets/images/subject/biology.svg'
import chemistry from  '../../../../../assets/images/subject/chemistry.svg'

const getSubjectImage = (title) => {
  switch (title) {
    case 'Биология': return biology
    case 'Химия': return  chemistry
    default: return defaultImage
  }
}
function SubjectCard() {
  const navigate = useNavigate();
  const [subjectsList, setSubjectsList] = useState([]);

  useEffect(() => {
    const fetchingSubjects = async () => {
      try {
        const data = await subjects();
        setSubjectsList(data);
      } catch (error) {
        setSubjectsList(null);
        throw new Error('Data unavaliable', error);
      }
    };
    fetchingSubjects();
  }, []);

  return (
    <div className="subject__card-container">
      {subjectsList.map((subject) => (
        <div
          className="subject__card-information"
          key={subject.id}
          onClick={() =>
            navigate(`/${subject.id}/courses`, {
              state: { subjectTitle: subject.title },
            })
          }
        >
          <div className="subject__card-image">
            <img
              src={getSubjectImage(subject.title)}
              alt={subject.title}
              className="subject__card-image-item"
            />
          </div>
          <div className="subject__card-title">
            <h2 className="subject__card-title-text">{subject.title}</h2>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SubjectCard;
